import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import Svg from '../shared/Svg';
import './MissingAttendee.scss';
import PropTypes from 'prop-types';
import * as RootActions from '../../actions/index';
import * as CalendarActions from '../../actions/calendar';
import officeApi from '../../../api/officeApi';
import colors from '../../utils/colors';
import { handleCreateContactBrowser, handleCreateContactDesktop } from '../../utils/calendar';
import { getSalesforceContacts } from '../../../api/emailsApi/calendar';
import { Tooltip } from '../shared/Tooltip';

export const MissingAttendee = ({ isOrganizer, email }) => {
  const dispatch = useDispatch();
  const isComposingEvent = useSelector((state) => state.calendar.isComposingEvent);
  const outlookEventAttendees = useSelector((state) => state.calendar.eventAttendees);
  const user = useSelector((state) => state.auth.user);
  const attendeeSettings = useSelector((state) => state.mail.settings?.calendarSettings?.attendeeContactSettings);
  const pmNamespace = useSelector((state) => state.mail.settings?.override?.pmNamespace || 'litify_pm');
  const { allowCreateContacts, attendeeType, recordType } = attendeeSettings ?? {};
  // double encode email to handle special characters like +
  const encodedEmail = encodeURIComponent(encodeURIComponent(email));
  let createLink = `${user.salesforceInstanceUrl}/lightning/o/${attendeeType === 'account' ? 'Account' : 'Contact'}/new?count=1&nooverride=1&useRecordTypeCheck=1`;

  if (attendeeType === 'account') {
    createLink += `&recordTypeId=${recordType}&defaultFieldValues=${pmNamespace}__Email__c=${encodedEmail}`;
  } else {
    createLink += `&defaultFieldValues=Email=${encodedEmail}`;
  }


  const onCreateClicked = async () => {
    try {
      await initiateCreateContact();
    } catch (e) {
      console.error(e);
      batch(() => {
        RootActions.changeAlertText('Error creating contact. Please try again.', 'error');
        dispatch(RootActions.isLoading(false));
      });
      return;
    }
  };

  const initiateCreateContact = async () => {
    if (officeApi.getPlatform() === 'OfficeOnline') {
      await handleCreateContactBrowser(createLink);
      dispatch(RootActions.isLoading(true));
      const attendeeMapping = await getSalesforceContacts([outlookEventAttendees.organizer, ...outlookEventAttendees.required, ...outlookEventAttendees.optional]);
      dispatch(CalendarActions.setSalesforceContactMap(attendeeMapping));
    } else {
      await handleCreateContactDesktop(createLink);
    }
  };

  const deleteAttendee = async () => {
    officeApi.removeEmailFromEvent(email, outlookEventAttendees);
    const [required, optional, organizer] = await Promise.all([...officeApi.getComposeEventAttendees()]);
    const eventAttendees = {
      organizer,
      required: Array.from(new Set([...required])),
      optional: Array.from(new Set([...optional])),
    };
    batch(() => {
      dispatch(CalendarActions.setEventAttendees(eventAttendees));
      dispatch(CalendarActions.attendeeChange());
    });
  };

  return (
    <div className='missing-attendee-card'>
      <Svg className='missing-attendee-image' data={'/assets/missing.svg'}/>
      <div className='missing-attendee-details'>
        <Tooltip textContent={email}>
          <span className='missing-attendee-email'>{email}</span>
        </Tooltip>
      </div>
      <div className='missing-attendee-iconsContainer'>
        {allowCreateContacts &&
          <span className='missing-attendee-create'
            onClick={onCreateClicked}>
            Create Contact
          </span>
        }
        {!isOrganizer && isComposingEvent && <Svg
          className="searchTableItem-closeIcon"
          data="../../../../assets/close.svg"
          fill={colors.searchGrey}
          tooltipContent={<span>Clear selection</span>}
          onClickAction={ deleteAttendee }
          hoverable
          hoverFill={colors.iconHover}
        />}
      </div>
    </div>
  );
};

MissingAttendee.propTypes = {
  isOrganizer: PropTypes.bool,
  email: PropTypes.string,
};
